module.exports = __webpack_public_path__ + "media/lendingtree/sofi-fe27cf71.jpg";